"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var specs_1 = require("./specs");
var errors_1 = require("./errors");
/** Returns true if the given object matches a spec. */
function is(value, type) {
    try {
        invariant(value, type);
        return true;
    }
    catch (_a) {
        return false;
    }
}
exports.is = is;
/** Checks if a given object matches a spec, then returns it. Throws an error if it doesn't. */
function invariant(value, type) {
    var func = desugarSpec(type);
    if (typeof func !== "function") {
        // todo more descriptive error
        throw new Error("invalid spec type.");
    }
    try {
        return func(value);
    }
    catch (e) {
        if (errors_1.SpecError.isSpecError(e)) {
            // e.path.unshift(name)
        }
        throw e;
    }
}
exports.invariant = invariant;
function desugarSpec(type) {
    if (type === undefined) {
        return specs_1.t.undefined();
    }
    else if (type === null) {
        return specs_1.t.null();
    }
    else if (Array.isArray(type)) {
        return specs_1.t.or.apply(specs_1.t, type);
    }
    else if (typeof type === "object") {
        return specs_1.t.object(type);
    }
    else if (typeof type === "string" || typeof type === "number" || typeof type === "boolean") {
        return specs_1.t.literal(type);
    }
    else if ("toSpec" in type) {
        return desugarSpec(type.toSpec());
    }
    else {
        return type;
    }
}
